// extracted by mini-css-extract-plugin
export default {"layout":"error-page_layout__b6uFa","label":"error-page_label__+asyv"};